import ApiService from "@/core/services/api.service";

const _ = require('lodash');

// API endpoints
export const GET_APPROVE_LEVEL_LIST = "level-management/list";
export const APPROVE_LEVELS = "level-management/approve";
export const GET_TEAMS = "level-management/get-department-head";
export const GET_LEVELS = "level-management/list-level-admin";
export const GET_DETAIL_MINUS_POINT = "level-management/detail-minus-point";
export const EXPORT_TEAMLEAD_SCORE_REVIEW = "teamlead-score-review/export";

const state = {
};

const getters = {
};

const actions = {
    [GET_APPROVE_LEVEL_LIST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_APPROVE_LEVEL_LIST, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                })
        });
    },

    [APPROVE_LEVELS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(APPROVE_LEVELS, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [GET_TEAMS](context) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${GET_TEAMS}`)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [GET_LEVELS](context) {
        return new Promise((resolve, reject) => {
            ApiService.query(`${GET_LEVELS}`)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [GET_DETAIL_MINUS_POINT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_DETAIL_MINUS_POINT, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                })
        });
    },
    [EXPORT_TEAMLEAD_SCORE_REVIEW](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(EXPORT_TEAMLEAD_SCORE_REVIEW, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                })
        });
    },
};

const mutations = {
};

export default {
    // follow existing pattern: non-namespaced so dispatch can be called without prefix
    state,
    actions,
    mutations,
    getters
};
